import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link } from 'react-router';
import { SubmissionError, reduxForm, reset } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import MasterDataManagementReitsHeader from '../../components/masterDataManagement/MasterDataManagementReitsHeader';
import * as authActions from '../../actions/authActions';
import * as dateHelpers from '../../scripts/dateHelpers';
import * as stringHelpers from '../../scripts/stringHelpers';
import * as clientActions from '../../actions/clientActions';
import * as commonActions from '../../actions/commonActions';
import * as reitActions from '../../actions/reitActions';
import * as actionHelpers from '../../scripts/actionHelpers';
import * as formHelpers from '../../scripts/formHelpers';
import * as masterDataManagementActions from '../../actions/masterDataManagementActions';
import MasterREITComponent from '../../components/masterDataManagement/MasterREITComponent';
import CreateEditReitModal from '../../components/reits/createEditReitModal';
import DeleteREITConfirmationModal from '../../components/masterDataManagement/DeleteREITConfirmationModal';
import UploadREITsModal from '../../components/masterDataManagement/UploadREITsModal';

/**
 * MasterDataManagementReitsContainer component
 * @extends {React.Component}
 */
class MasterDataManagementReitsContainer extends Component {
  /**
   * Creates a new MasterDataManagementReitsContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
    this.state = {
      // Define initial state here
      showReitForm: false,
      reitFormPurpose: '',
      initialValues: null,
      reitFormInitialValues: null,
      lookupTypes: [],
      groupsData: [],
      selectedReit: {
        reitid: 0,
        reitName: '',
        reitShortName: '',
        initialQuarter: '',
        reitTypeID: '',
        numberOfSharesClasses: 0,
        preferredNumberOfShareHolders: 0,
        StateOrganized: '',
        Symbol: '',
        balanceThreshold: 0,
        percentageThreshold: 0,
        ein: '',
        organizationTypeID: '',
        periodQuarter: dateHelpers.getQuarter(),
        periodYear: dateHelpers.getYear(),
        showDeactivateErrorMessageModal: false,
      },
      hideReitSuccessMessage: false,
      showReitSuccess: false,
      gridCurrentState: [],
      gridColumnState: [],
      refreshGridREITData: {
        refreshGridOnCompletedAction: -1,
      },
      showDeleteREITConfirmationModal: false,
      showDeleteREITErrorMessageModal: false,
      showUploadREITsModal: false,
      apiErrorMessage: '',
    };
    this.showReitForm = this.showReitForm.bind(this);
    this.handleCloseReitForm = this.handleCloseReitForm.bind(this);
    this.handleReitSubmit = this.handleReitSubmit.bind(this);
    this.handleReitCreateSubmit = this.handleReitCreateSubmit.bind(this);
    this.handleReitEditSubmit = this.handleReitEditSubmit.bind(this);
    this.handleEditReitClick = this.handleEditReitClick.bind(this);
    this.handleDismissReitErrorMessage =
      this.handleDismissReitErrorMessage.bind(this);
    this.updateReit = this.updateReit.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.fetchGroupsData = this.fetchGroupsData.bind(this);
    this.getClientData = this.getClientData.bind(this);
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.setGridColumnState = this.setGridColumnState.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.handleDeleteReitClick = this.handleDeleteReitClick.bind(this);
    this.toggleShowDeleteREITConfirmationModal =
      this.toggleShowDeleteREITConfirmationModal.bind(this);
    this.handleConfirmDeleteReitClick =
      this.handleConfirmDeleteReitClick.bind(this);
    this.handleExportREITTemplate = this.handleExportREITTemplate.bind(this);
    this.toggleUploadREITsModal = this.toggleUploadREITsModal.bind(this);
    this.handleUploadREITTemplate = this.handleUploadREITTemplate.bind(this);
    this.handleDownloadMasterDataReport =
      this.handleDownloadMasterDataReport.bind(this);
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    // Fetch initial data here
    const { clientId } = this.props;
    if (clientId) {
      this.props.reitActions.fetchReits(clientId, true);
      this.props.masterDataManagementActions.fetchGroupsData(clientId);
      this.props.reitActions.fetchReitLookupTypes();
      this.getClientData();
    }
  }

  componentWillUnmount() {
    this.setState({ groupsData: [], reits: [] });
  }

  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }

  handleExportREITTemplate(restrictedReportPeriodLimitFlag) {
    this.props.masterDataManagementActions.exportREITsData(
      this.props.clientId,
      restrictedReportPeriodLimitFlag
    );
  }

  handleDownloadMasterDataReport() {
    this.props.masterDataManagementActions.exportAllTypesData(
      this.props.clientId
    );
  }

  showReitForm(e) {
    e.preventDefault();
    const selectedReit = {
      reitid: 0,
      reitName: '',
      reitShortName: '',
      reitTypeID: '',
      balanceThreshold: '',
      percentageThreshold: '',
      numberOfSharesClasses: '',
      preferredNumberOfShareHolders: '',
      stateOrganized: '',
      organizationTypeID: '',
      entityGroupID: -1,
      reitTrackingID: stringHelpers.GetRandomX9Xxx9XxxString(6),
      clientEntityID: '',
      gtpEntityID: '',
      initialQuarter: `Q${dateHelpers.getQuarter()} ${dateHelpers.getYear()}`,
    };

    let reitFormInitialValues = Object.assign({}, selectedReit);
    this.props.clientActions.loadClient(this.props.clientId).then(() => {
      this.setState({
        showReitForm: true,
        reitFormPurpose: '',
        selectedReit: selectedReit,
        reitFormInitialValues: reitFormInitialValues,
      });
    });
  }

  handleCloseReitForm() {
    this.setState({ showReitForm: false });
  }

  handleReitSubmit(values, e) {
    this.setState({ hideReitSuccessMessage: false });

    let reitToHandle = Object.assign({}, values);
    if (values.ein && values.ein.indexOf('-') === -1) {
      reitToHandle.ein = `${values.ein.slice(0, 2)}-${values.ein.slice(2)}`;
    }
    if (this.state.reitFormPurpose === 'EDIT') {
      return this.handleReitEditSubmit(reitToHandle);
    }

    return this.handleReitCreateSubmit(reitToHandle);
  }

  handleReitCreateSubmit(values) {
    this.props.commonActions.beginTask();

    this.setState({ showReitSuccess: false });
    if (this.props.clientId === 0) {
      this.props.commonActions.endTask();
      throw new SubmissionError({
        _error: 'A REIT must be associated with a client.',
      });
    }

    const reit = {
      reitID: this.props.reitID,
      reitName: values.reitName,
      reitShortName: values.reitShortName,
      balanceThreshold: values.balanceThreshold,
      percentageThreshold: values.percentageThreshold,
      reitTypeID: values.reitTypeID || 0,
      numberOfSharesClasses: values.numberOfSharesClasses || 0,
      preferredNumberOfShareHolders: values.preferredNumberOfShareHolders || 0,
      stateOrganized: values.stateOrganized,
      clientId: this.props.clientId,
      dateOfElection: values.dateOfElection,
      symbol: values.symbol,
      ein: values.ein,
      organizationTypeID: values.organizationTypeID,
      formationDate: values.formationDate,
      periodQuarter: values.initialQuarter.split(' ')[0].charAt(1),
      periodYear: parseInt(values.initialQuarter.split(' ')[1], 10),
      initialQuarter: values.initialQuarter,
      entityGroupID:
        values.entityGroupID && parseInt(values.entityGroupID, 10) === -1
          ? null
          : values.entityGroupID,
      reitTrackingID: values.reitTrackingID,
      clientEntityID: values.clientEntityID,
      gtpEntityID: values.gtpEntityID,
    };

    //Create Reit
    return reitActions.createReit(reit).then((data) => {
      if (actionHelpers.isErrorResponse(data)) {
        this.props.commonActions.endTask();
        return formHelpers.generateSubmissionError(data);
      }

      this.props.reitActions.fetchReits(this.props.clientId, true);
      this.handleCloseReitForm();
      this.setState({ showReitSuccess: true });
      this.props.commonActions.endTask();
    });
  }

  handleReitEditSubmit(values) {
    this.props.commonActions.beginTask();

    this.setState({ showReitSuccess: false });
    if (this.props.clientId === 0) {
      throw new SubmissionError({
        _error: 'A REIT must be associated with a client.',
      });
    }
    const reit = {
      reitID: values.reitid,
      reitName: values.reitName,
      reitShortName: values.reitShortName,
      balanceThreshold: values.balanceThreshold,
      dateOfElection: values.dateOfElection,
      percentageThreshold: values.percentageThreshold,
      reitTypeID: values.reitTypeID || 0,
      numberOfSharesClasses: values.numberOfSharesClasses || 0,
      preferredNumberOfShareHolders: values.preferredNumberOfShareHolders || 0,
      stateOrganized: values.stateOrganized,
      symbol: values.symbol,
      clientId: this.props.clientId,
      ein: values.ein,
      organizationTypeID: values.organizationTypeID,
      formationDate: values.formationDate,
      entityGroupID:
        values.entityGroupID && parseInt(values.entityGroupID, 10) === -1
          ? null
          : values.entityGroupID,
      clientEntityID: values.clientEntityID,
      gtpEntityID: values.gtpEntityID,
    };

    return this.updateReit(reit);
  }

  updateReit(reit) {
    return reitActions
      .updateReit(reit)
      .then((data) => {
        if (actionHelpers.isErrorResponse(data)) {
          this.props.commonActions.endTask();
          return formHelpers.generateSubmissionError(data);
        }
        this.props.reitActions.fetchReits(this.props.clientId, true);
        this.handleCloseReitForm();
        this.setState({ showReitSuccess: true });
        this.props.commonActions.endTask();
        return;
      })
      .catch((err) => {
        if (err instanceof SubmissionError) {
          throw err;
        }

        this.props.commonActions.endTask();
        formHelpers.generateSubmissionError();
      });
  }

  handleEditReitClick(values) {
    const reit = {
      reitid: values.reitid,
      reitName: values.reitName,
      reitShortName: values.reitShortName,
      balanceThreshold: values.balanceThreshold || '0.00',
      dateOfElection: values.dateOfElection,
      percentageThreshold: values.percentageThreshold || '0.00',
      reitTypeID: values.reitTypeID || 0,
      numberOfSharesClasses: values.numberOfSharesClasses || 0,
      preferredNumberOfShareHolders: values.preferredNumberOfShareHolders || 0,
      stateOrganized: values.stateOrganized,
      symbol: values.symbol,
      clientId: values.clientId,
      ein: values.ein,
      organizationTypeID: values.organizationTypeID,
      formationDate: values.formationDate,
      initialQuarter: values.initialQuarter,
      entityGroupID: values.entityGroupID,
      reitTrackingID: values.reitTrackingID,
      clientEntityID: values.clientEntityID,
      gtpEntityID: values.gtpEntityID,
    };

    let reitFormInitialValues = Object.assign({}, reit);
    this.setState({
      showReitForm: true,
      reitFormPurpose: 'EDIT',
      selectedReit: reit,
      reitFormInitialValues: reitFormInitialValues,
    });
  }

  handleDeleteReitClick(values) {
    if (values) {
      const reit = {
        reitid: values.reitid,
        reitName: values.reitName,
      };

      let reitFormInitialValues = Object.assign({}, reit);
      this.setState({
        showDeleteREITConfirmationModal: true,
        selectedReit: reit,
        reitFormInitialValues: reitFormInitialValues,
        apiErrorMessage: '', // Clear any previous error message
      });
    }
  }

  handleDismissReitErrorMessage() {
    this.props.commonActions.clearFormErrors('reit');
  }

  fetchGroupsData() {
    const { clientId } = this.props;
    if (clientId) {
      this.props.masterDataManagementActions.fetchGroupsData(clientId);
    }
  }

  getClientData() {
    this.props.clientActions.loadClient(this.props.clientId).then(() => {
      this.setState({ isAudit: this.props.isAudit });
    });
  }

  handleGridChanges(gridRowData) {
    let rowData = [];
    rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          reitID: x.reitID,
          balanceThreshold: x.balanceThreshold,
          dateOfElection: x.dateOfElection,
          ein: x.ein,
          formationDate: x.formationDate,
          isActive: x.isActive,
          reitName: x.reitName,
          periods: x.periods,
          reitDependentEntityData: x.reitDependentEntityData,
          organizationTypeID: x.organizationTypeID,
          organizationTypeDescription: x.organizationTypeDescription,
          percentageThreshold: x.percentageThreshold,
          preferredNumberOfShareHolders: x.preferredNumberOfShareHolders,
          reitTypeID: x.reitTypeID,
          reitTypeDescription: x.reitTypeDescription,
          numberOfSharesClasses: x.numberOfSharesClasses,
          reitShortName: x.reitShortName,
          stateOrganized: x.stateOrganized,
          symbol: x.symbol,
          reitTrackingID: x.reitTrackingID,
          discrepancyCount: x.discrepancyCount,
          entityGroupID: x.entityGroupID,
          entityGroupName: x.entityGroupName,
          initialQuarter: x.initialQuarter,
          clientEntityID: x.clientEntityID,
          gtpEntityID: x.gtpEntityID,
        };
      });
    this.setState({ gridCurrentState: rowData });
  }

  setGridColumnState() {
    let columnState = localStorage.getItem(
      'REITSuiteMasterREITDataColumnState'
    );
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }

  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  toggleShowDeleteREITConfirmationModal() {
    this.setState({
      showDeleteREITConfirmationModal:
        !this.state.showDeleteREITConfirmationModal,
    });
  }

  handleConfirmDeleteReitClick = (values) => {
    if (values) {
      this.props.reitActions
        .deleteREIT(this.props.clientId, this.state.selectedReit.reitid)
        .then((response) => {
          if (response && response.success) {
            this.setState({
              showDeleteREITConfirmationModal: false,
              selectedReit: null,
              reitFormInitialValues: null,
              apiErrorMessage: '', // Clear any previous error message
            });
            this.props.reitActions.fetchReits(this.props.clientId, true);
          } else {
            this.setState({
              apiErrorMessage:
                response?.errorMessage ||
                'An error occurred while deleting the REIT.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            apiErrorMessage: error.message || 'An unexpected error occurred.',
          });
        });
    }
  };

  handleUploadREITTemplate() {
    this.setState({ showUploadREITsModal: true });
  }

  toggleUploadREITsModal = () => {
    this.setState({ showUploadREITsModal: !this.state.showUploadREITsModal });
    this.props.reitActions.fetchReits(this.props.clientId, true);
  };

  render() {
    return (
      <React.Fragment>
        <h2 data-testid="pghdrMasterDataManagement">Master Data Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/groups`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(1)}
              data-testid="tbGroups"
            >
              Groups
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/reits`}
            tabIndex="-1"
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              onClick={() => this.handleTabClick(2)}
              data-testid="tbREITs"
            >
              REITs
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/properties`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(3)}
              data-testid="tbProperties"
            >
              Properties
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/securities`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(4)}
              data-testid="tbSecurities"
            >
              Securities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/trs`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(5)}
              data-testid="tbTrs"
            >
              Taxable REIT Subsidiaries
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>

        <MasterDataManagementReitsHeader
          isSystemOrEngagementAdmin={
            authActions.isSystemAdministrator(
              this.props.currentUserAuthorizations
            ) ||
            authActions.isEngagementAdministrator(
              this.props.currentUserAuthorizations,
              this.props.clientId
            )
          }
          handleAddReit={this.showReitForm}
          handleUploadREITTemplate={this.handleUploadREITTemplate}
          handleExportREITTemplate={this.handleExportREITTemplate}
          handleDownloadMasterDataReport={this.handleDownloadMasterDataReport}
        />

        <CreateEditReitModal
          isOpen={this.state.showReitForm}
          handleModalClose={this.handleCloseReitForm}
          reitFormPurpose={this.state.reitFormPurpose}
          handleSubmit={this.handleReitSubmit}
          initialValues={this.state.reitFormInitialValues}
          handleDismissErrorMessage={this.handleDismissReitErrorMessage}
          lookupTypes={this.props.lookupTypes}
          isAudit={this.props.isAudit}
          groupsData={this.props.groupsData}
        />

        {this.state.showUploadREITsModal && (
          <UploadREITsModal
            show={this.state.showUploadREITsModal}
            onClose={this.toggleUploadREITsModal}
          />
        )}

        <MasterREITComponent
          reitsData={this.props.reits}
          handleEditButtonClick={this.handleEditReitClick}
          handleDeleteButtonClick={this.handleDeleteReitClick}
          handleGridColumnStateChange={this.handleGridColumnStateChange}
          handleGridChanges={this.handleGridChanges}
          gridColumnState={this.state.gridColumnState}
          currentUserIsSysAdmin={authActions.isSystemAdministrator(
            this.props.currentUserAuthorizations
          )}
          currentUserIsEngAdmin={authActions.isEngagementAdministrator(
            this.props.currentUserAuthorizations,
            this.props.clientId
          )}
        />
        <DeleteREITConfirmationModal
          showDeleteREITConfirmationModal={
            this.state.showDeleteREITConfirmationModal
          }
          handleConfirm={this.handleConfirmDeleteReitClick}
          toggleShowDeleteREITConfirmationModal={
            this.toggleShowDeleteREITConfirmationModal
          }
          initialValues={this.state.selectedReit}
          apiErrorMessage={this.state.apiErrorMessage}
          handleDismissErrorMessage={this.handleDismissReitErrorMessage}
        />
      </React.Fragment>
    );
  }
}

MasterDataManagementReitsContainer.propTypes = {
  clientId: PropTypes.number,
  isAudit: PropTypes.bool,
  groupsData: PropTypes.array,
  lookupTypes: PropTypes.object,
  currentUserAuthorizations: PropTypes.array,
  clientActions: PropTypes.object.isRequired,
  commonActions: PropTypes.object.isRequired,
  reitActions: PropTypes.object.isRequired,
  masterDataManagementActions: PropTypes.object.isRequired,
  reits: PropTypes.array,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    clientId: cid,
    isAudit: state.client && state.client.isAudit,
    currentUserAuthorizations: state.currentUserAuthorizations,
    lookupTypes: state.lookupTypes,
    groupsData: state.groupsData,
    selectedReit: state.reit.selectedReit,
    reits: state.reits,
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    reitActions: bindActionCreators(reitActions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    masterDataManagementActions: bindActionCreators(
      masterDataManagementActions,
      dispatch
    ),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'masterDataManagementReitsForm',
      enableReinitialize: true,
    })(MasterDataManagementReitsContainer)
  )
);
